import React, { useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography, Breadcrumbs, Link, Paper } from "@material-ui/core";

// Contexts
import OrderContext from "../../../../context/orders/v1/OrdersContext";

// Components
import OrderSearchBar from "./OrderSearchBar";
import OrderSearchResult from "./OrderSearchResult";

// Material UI Styling
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

const OrderHome = () => {
  const classes = useStyles();

  const { searchFilter, searchResult, searchOrder } = useContext(OrderContext);

  useEffect(() => {
    // Update Search Result
    if (searchFilter.value) {
      searchOrder();
    }
  }, []);

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        <Grid container spacing={0} justifyContent="flex-start">
          <Grid item xs={12}>
            <Typography variant="h4"> Order </Typography>{" "}
          </Grid>{" "}
          <Grid item xs={12}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit"> Order </Link>{" "}
            </Breadcrumbs>{" "}
          </Grid>{" "}
        </Grid>
        <Grid item xs={12}>
          <Paper className={classes.paper}>
            <Grid container spacing={3} direction="column" justifyContent="flex-start">
              {" "}
              {/* Search Bar */}{" "}
              <Grid item xs={6}>
                <OrderSearchBar />
              </Grid>
              {/* Search Result */}{" "}
              <Grid item xs={12}>
                {" "}
                {searchResult && <OrderSearchResult />}{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Paper>{" "}
        </Grid>{" "}
      </Grid>{" "}
    </div>
  );
};

export default OrderHome;
